<template>
<ItpPage
  no-primary-button
  :closeButtonText="'Close'|gettext"
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="ContractServiceFee"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded && !noHeader"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    stretch
    v-if="loaded"
  >
    <ItpForm
      :id="formId"
      :name="formName"
      class="row"
      ref="mainForm"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <ItpCol>
        <ItpFormGroup
          name="contract"
          :label="'Contract'|pgettext('ContractServiceEditor')"
          labelColsMd="3"
          contentColsMd="9"
          :labelAlign="labelAlign"
          contentClass="form-control form-control-readonly"
          v-if="displayParent && item.contract"
        >
          <UcContractMiniCard
            :item="item.contract"
            no-link
          >
          </UcContractMiniCard>
        </ItpFormGroup>
        <ItpFormGroup
          name="contract"
          :label="'Service'|pgettext('ContractServiceEditor')"
          labelColsMd="3"
          contentColsMd="9"
          :labelAlign="labelAlign"
          contentClass="form-control form-control-readonly"
          v-if="displayParent && item.contract_service"
        >
          <span>
            {{ item.contract_service.name }}
          </span>
        </ItpFormGroup>
        <hr
          v-if="displayParent"
        >
        </hr>
        <FieldsetContractServiceFee
          :item="item"
        >
        </FieldsetContractServiceFee>
        <DIV
          class="offset-3"
        >
          <ItpButton
            :text="'Save'|pgettext('Button')"
            :disabled="!forms[formName] || !forms[formName].submittable"
            type="submit"
            :form="formId"
            variant="primary"
            icon="fa-save"
            :spinning="actions.save.isRunning"
            v-if="inlineCommands"
          >
          </ItpButton>
        </DIV>
      </ItpCol>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded && !noFooter"
  >
    <ItpButton
      :text="'Save'|pgettext('Button')"
      :disabled="!forms[formName] || !forms[formName].submittable"
      type="submit"
      :form="formId"
      variant="primary"
      icon="fa-save"
      :spinning="actions.save.isRunning"
    >
    </ItpButton>
    <ItpButton
      :text="'Close'|gettext"
      variant="default"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class ContractServiceFee extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  getServiceDescription(...args: any[]) {
    const [data] = args;
    const result = [];

    if (data.contract) {
      result.push(data.contract.contract_number);
    }
    if (data.contract_service) {
      result.push(data.contract_service.name);
    }
    if (result.length) {
      return result.join(" / ")
    }
  }

  @Prop({
    type: String,
  })
  oid!: string;

  @Watch('oid')
  onOid(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("oid")
  }

  @Prop({
    type: Boolean,
  })
  noHeader!: boolean;

  @Watch('noHeader')
  onNo_header(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("noHeader")
  }

  @Prop({
    type: Boolean,
  })
  noFooter!: boolean;

  @Watch('noFooter')
  onNo_footer(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("noFooter")
  }

  @Prop({
    type: Boolean,
    default: true,
  })
  displayParent!: boolean;

  @Watch('displayParent')
  onDisplay_parent(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("displayParent")
  }

  @Prop({
    type: Boolean,
    default: false,
  })
  inlineCommands!: boolean;

  @Watch('inlineCommands')
  onInline_commands(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("inlineCommands")
  }

  @Prop({
    type: String,
    default: "lg",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  formName!: any;
  item!: any;

  async $$load_item() {
    return this.$fn.fetch('read_contract_service_fee', { parameters: { id: this.oid } })
  }

  serviceDescription!: any;

  async $$load_serviceDescription() {
    return this.getServiceDescription(this.item)
  }

  labelAlign!: any;
  billingCategories!: any;

  async $$load_billingCategories() {
    return this.$fn.fetch('get_tags', { parameters: { tag_type: 'billing_category' } })
  }

  messages!: any;
  currencies!: any;

  async $$load_currencies() {
    return this.$fn.fetch('list_currency')
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  dataMembers = ['formId', 'formName', 'item', 'serviceDescription', 'labelAlign', 'billingCategories', 'messages', 'currencies', 'ux', 'b_7315092382398562_modalBindings'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        formId: null,
        formName: "ContractServiceFee",
        item: null,
        serviceDescription: null,
        labelAlign: "right",
        billingCategories: null,
        messages: {
          addService: {
            title: this.$fn.pgettext("Contract", "Add Service"),
          }
          ,
          editService: {
            title: this.$fn.pgettext("Contract", "Edit Service"),
          }
          ,
          addServiceFee: {
            title: this.$fn.pgettext("Contract", "Add Service Fee"),
          }
          ,
          editServiceFee: {
            title: this.$fn.pgettext("Contract", "Edit Service Fee"),
          }
          ,
        }
        ,
        currencies: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          noPrimaryButton: true,
          closeButtonText: this.$fn.gettext("Close"),
          size: "lg",
        }
        ,
      },
    }
  }

  get isReadonly() {
    if (this.loaded) {

      return this.item && this.item.isReadonly
    }
    return null;
  }

  get document() {
    if (this.loaded) {

      return {
        title: [this.serviceDescription
          ,
        this.$fn.pgettext("ContractServiceFee", "fee")
          ,
        ]
        ,
        icon: this.$config.contract.icon,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_2760_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_2760, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_closeModal_2766_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1040167445267876_closeModal_2766, alias=undefined
    return {
      result: {
        ok: true,
        value: $event.data,
      }
      ,
    }
  }

  async evh_1040167445267876_success_2765_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_1040167445267876_success_2765, alias=undefined
    return this.modal
  }

  async act_1040167445267876_crud_2764_getActionArgs($event: actions.ActionEvent): Promise<actions.CRUDActionArgs> {
    // parameterResolver name=act_1040167445267876_crud_2764, alias=save
    return {
      objectType: "contract_service_fee",
      op: "upsert",
      data: this.item,
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_2760: actions.CloseModalAction;
    evh_7315092382398562_close_2759: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_2762: actions.CloseComponentAction;
    evh_2248226175642056_close_2761: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_1040167445267876_closeModal_2766: actions.CloseModalAction;
    evh_1040167445267876_success_2765: actions.EventHandlerImpl;
    act_1040167445267876_crud_2764: actions.CRUDAction;
    evh_1040167445267876_submit_2763: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_1419464017721962_closeComponent_2768: actions.CloseComponentAction;
    evh_1419464017721962_clickPreventStop_2767: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_2760 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_2760_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_2759 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_2760,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_2759],
      }
    );
    const act_2248226175642056_closeComponent_2762 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_2761 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_2762,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_2761],
      }
    );
    const act_1040167445267876_closeModal_2766 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1040167445267876_closeModal_2766_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_2765 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeModal_2766,
        event: "success",
        when: this.evh_1040167445267876_success_2765_getWhen,
        displayName: "closeModal",
      }
    );
    const act_1040167445267876_crud_2764 = new actions.CRUDAction(
      {
        actionArgs: this.act_1040167445267876_crud_2764_getActionArgs,
        displayName: "save",
        events: [evh_1040167445267876_success_2765],
      }
    );
    const evh_1040167445267876_submit_2763 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_crud_2764,
        event: "submit",
        displayName: "save",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_2763],
      }
    );
    const act_1419464017721962_closeComponent_2768 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_2767 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeComponent_2768,
        event: "click.prevent.stop",
        displayName: "closeComponent",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_2767],
      }
    );
    return {
      act_7315092382398562_closeModal_2760,
      evh_7315092382398562_close_2759,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_2762,
      evh_2248226175642056_close_2761,
      evh_2248226175642056_close,
      act_1040167445267876_closeModal_2766,
      evh_1040167445267876_success_2765,
      act_1040167445267876_crud_2764,
      evh_1040167445267876_submit_2763,
      evh_1040167445267876_submit,
      act_1419464017721962_closeComponent_2768,
      evh_1419464017721962_clickPreventStop_2767,
      evh_1419464017721962_clickPreventStop,
      save: act_1040167445267876_crud_2764,
    }
  }
}

Vue.component("ContractServiceFee", ContractServiceFee);

</script>